import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-flip-delete-confirm-modal',
  templateUrl: './flip-delete-confirm-modal.component.html',
  styleUrls: ['./flip-delete-confirm-modal.component.scss'],
  standalone: false,
})
export class FlipDeleteConfirmModalComponent {
  constructor(public dialogRef: MatDialogRef<FlipDeleteConfirmModalComponent>) {}

  close(confirmed: boolean) {
    this.dialogRef.close(confirmed)
  }
}
